import { trackEvent } from '@/lib/product-analytics'

/** @deprecated Prefer trackEvent — kept for existing meeting-waste call sites. */
export function trackRybbitEvent(name: string, props?: Record<string, string | number>) {
  trackEvent(name, props)
}
